import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/login/Login.tsx";
import React from "react";

export const PublicRoutes = ({redirect}) => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="/noc/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      {redirect === false && (
        <Route path="/*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
};
